import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EscrowCard = ({ escrow, onRelease, onDispute }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })?.format(new Date(date));
  };

  const calculateProgress = () => {
    return (escrow?.completedMilestones / escrow?.totalMilestones) * 100;
  };

  return (
    <div className="p-6 bg-card border border-border rounded-lg">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-semibold text-foreground mb-1">{escrow?.campaignName}</h3>
          <p className="text-sm text-muted-foreground">{escrow?.influencerName}</p>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold text-foreground">{formatAmount(escrow?.amount)}</p>
          <p className="text-xs text-muted-foreground mt-1">Emanet Tutarı</p>
        </div>
      </div>
      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between text-sm mb-2">
            <span className="text-muted-foreground">İlerleme Durumu</span>
            <span className="font-medium text-foreground">
              {escrow?.completedMilestones}/{escrow?.totalMilestones} Kilometre Taşı
            </span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div 
              className="h-full bg-primary transition-all duration-300"
              style={{ width: `${calculateProgress()}%` }}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 py-4 border-t border-border">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Başlangıç Tarihi</p>
            <p className="text-sm font-medium text-foreground">{formatDate(escrow?.startDate)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Bitiş Tarihi</p>
            <p className="text-sm font-medium text-foreground">{formatDate(escrow?.endDate)}</p>
          </div>
        </div>

        {escrow?.nextMilestone && (
          <div className="p-3 bg-primary/5 border border-primary/20 rounded-lg">
            <div className="flex items-start gap-2">
              <Icon name="Target" size={16} color="var(--color-primary)" className="mt-0.5" />
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground mb-1">Sonraki Kilometre Taşı</p>
                <p className="text-xs text-muted-foreground">{escrow?.nextMilestone}</p>
              </div>
            </div>
          </div>
        )}

        <div className="flex gap-2 pt-2">
          <Button
            variant="outline"
            size="sm"
            iconName="AlertCircle"
            iconPosition="left"
            onClick={() => onDispute(escrow)}
            className="flex-1"
          >
            İtiraz Et
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="CheckCircle"
            iconPosition="left"
            onClick={() => onRelease(escrow)}
            disabled={escrow?.completedMilestones < escrow?.totalMilestones}
            className="flex-1"
          >
            Ödemeyi Serbest Bırak
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EscrowCard;